export type ErrorLike =
  | {
      code?: string;
      status?: number;
      [prop: string]: any;
    }
  | string;

export const getRelatedCodesForError = (
  error?: ErrorLike | string
): string[] => {
  const relatedCodes = [];

  if (error) {
    if (typeof error !== 'string') {
      if (error.code) {
        relatedCodes.push(error.code);
      }

      if (typeof error.status === 'number') {
        const status = String(error.status);
        relatedCodes.push(status);

        if (status.length === 3) {
          relatedCodes.push(`${status[0]}xx`);
        }
      }
    }
  }

  return relatedCodes;
};

export default getRelatedCodesForError;
